import N from "../../../node_modules/classnames/index.js";
import { forwardRef as p } from "react";
import "./button2.js";
import { jsxs as n, jsx as t } from "../../../_virtual/jsx-runtime.js";
const z = p(({
  className: e,
  type: o = "button",
  size: i = "medium",
  variant: s = "filled",
  iconVariant: c,
  onClick: r,
  onBlur: d,
  onMouseEnter: m,
  onMouseLeave: l,
  selected: u = !1,
  children: _,
  tabIndex: b,
  disabled: f,
  icon: a
}, v) => /* @__PURE__ */ n("button", {
  tabIndex: b,
  ref: v,
  type: o,
  disabled: f,
  onClick: r,
  onBlur: d,
  onMouseEnter: m,
  onMouseLeave: l,
  "data-selected": u,
  "data-icon-variant": c,
  "data-variant": s,
  "data-size": i,
  className: N("button", e),
  children: [/* @__PURE__ */ n("div", {
    className: "button__main-container",
    children: [a && /* @__PURE__ */ t("div", {
      className: "button__icon-container",
      children: a
    }), /* @__PURE__ */ t("div", {
      className: "button__content-container",
      children: _
    })]
  }), /* @__PURE__ */ t("div", {
    className: "button__selected-icon-container"
  })]
}));
export {
  z as Button
};
//# sourceMappingURL=Button.js.map
